// extracted by mini-css-extract-plugin
export var banner = "_3n-0";
export var icon = "_3n-1";
export var message = "_3n-2";